import _, { isObject } from "lodash"
import {
  GetCategoriesFromFeatures,
  GetCategoryOptions,
  GetFeatureQuickSearchConfigByVenue,
  IFeatureCategoryObj,
  SanitizeFeatureId,
  SortCategoryObjByOrder,
} from "../types"
import { AmenityData, OccupantData } from "providers/venue/types"

const sortCategoryObjByOrder: SortCategoryObjByOrder = (
  categoryObj,
  config = []
) => {
  const { type, category } = categoryObj
  const indexOrder = config.findIndex(
    (categoryOrder) => categoryOrder === `${type}.${category}`
  )
  // If category not found it will be sent to last item
  return indexOrder !== -1 ? indexOrder : 9999
}

export const getFeatureQuickSearchConfigByVenue: GetFeatureQuickSearchConfigByVenue =
  (config, reference) => {
    return isObject(config) ? config[reference] : null
  }

export const getCategoryOptions: GetCategoryOptions = (categories = []) => {
  return _(categories)
    .map((categoryName): IFeatureCategoryObj => {
      const [type, ...rest] = categoryName.split(".")
      const category = rest.join(".")
      if (!type || !category) return null

      return {
        type,
        category,
      }
    })
    .compact()
    .value()
}

export const getCategoriesFromFeatures: GetCategoriesFromFeatures<
  OccupantData | AmenityData
> = (features = [], config = []) => {
  return _(features)
    .uniqBy((feature) => feature.properties.category)
    .filter(
      (feature) =>
        feature.properties.category &&
        config.includes(
          `${feature.feature_type}.${feature.properties.category}`
        )
    )
    .map(
      (feature): IFeatureCategoryObj => ({
        type: feature.feature_type,
        category: feature.properties.category,
      })
    )
    .orderBy([
      // First Sort by prioritize order from config
      (categoryObj: IFeatureCategoryObj) =>
        sortCategoryObjByOrder(categoryObj, config),
      // When order is the same sort by alphabet
      (categoryObj: IFeatureCategoryObj) => categoryObj.category.toLowerCase(),
    ])
    .value()
}

// Remove "m" suffix from maintenance record ID to match the source feature ID (e.g., "occupant-123m" → "occupant-123").
export const sanitizeFeatureId: SanitizeFeatureId = (featureId) => {
  if (!featureId) return
  return `${featureId}`.replace(/m$/, "")
}
